import { ReactSelectBox, Row, Col, Label, Quantity, PrimaryButton, OutlineButton } from '../../../../../CommonComponents';
import { isMaxLength, isNumber } from 'utils';
import CancelConfirmationPopup from 'client/CommonComponents/DialogBox/CancelConfirmationPopup';
import permissions, { isAuthorized } from 'client/utils/Permissions';

const ManagmentVehicle = (props: any) => {

  const { fuelTypeOnChange, dropDownValues, showDropDown, showAddItem } = props

  const orderDetails = props.orderDetails
  const onIncrementQuantity = props.onIncrementQuantity
  const onDecrementQuantity = props.onDecrementQuantity
  const onChangeQuantity = props.onChangeQuantity
  const onChangeDriverTitle = props.onChangeDriverTitle
  const managementRef = props.managementRef
  const managementVehicleValidation = props.managementVehicleValidation
  const popupContent = props.popupContent
  const hideDialog = props.hideDialog
  const onChangesVehicle = props.onChangesVehicle
  const onChangeDriveTrain = props.onChangeDriveTrain
  const updateOnClick = props.updateOnClick;
  const isEditRequestClick = props.isEditRequestClick
  const cancelEditRequestType = props.cancelEditRequestType

  return <div className='management-vehicle mb-2 p-3'>
    <Row>
    {showDropDown?.showDriverTitle ?
      <Col xs={12} sm={4} md={4} lg={4} className='mb-md-3 mb-2'>
        <Label required data-attribute="ManagementVehicle_Default_Label">Driver Title</Label>
        <ReactSelectBox
          options={dropDownValues?.driverTitleDropDown}
          onChange={(item: any) => onChangeDriverTitle(item)}
          value={orderDetails.driverTitle}
          selectRef={(element: any) => managementRef.current[0] = element}
          isSearchable={true}
          className={managementVehicleValidation.driverTitleError.length > 0 ? 'controlValidation' : ''}
         data-attribute="ManagementVehicle_Default_SearchSelectBox" />
        {managementVehicleValidation.driverTitleError.length > 0 ? <p className='validMessage'>{managementVehicleValidation.driverTitleError}</p> : null}
      </Col>
      : null}
      {showDropDown?.showVehicle ?
      <Col xs={12} sm={4} md={4} lg={4} className='mb-md-3 mb-2'>
        <Label required data-attribute="ManagementVehicle_Default_Label_2">Vehicle</Label>
        <ReactSelectBox
          options={dropDownValues?.vehicleDropDown}
          onChange={(item: any) => onChangesVehicle(item)}
          value={orderDetails.vehicleType}
          className={managementVehicleValidation.vehicleError.length > 0 ? 'controlValidation' : ''}
          selectRef={(element: any) => managementRef.current[1] = element}
         data-attribute="ManagementVehicle_Default_SearchSelectBox_2" />
        {managementVehicleValidation.vehicleError.length > 0 ? <p className='validMessage'>{managementVehicleValidation.vehicleError}</p> : null}
      </Col>
      : null}
      {showDropDown?.showDriveTrain ?
      <Col xs={12} sm={4} md={4} lg={4} className='mb-md-3 mb-2'>
        <Label required data-attribute="ManagementVehicle_Default_Label_3">Drive Train</Label>
        <ReactSelectBox
          options={dropDownValues?.driveTrainDropDown}
          onChange={(item: any) => onChangeDriveTrain(item)}
          value={orderDetails.driveTrain}
          selectRef={(element: any) => managementRef.current[2] = element}
          className={managementVehicleValidation.driveTrainError.length > 0 ? 'controlValidation' : ''}
         data-attribute="ManagementVehicle_Default_SearchSelectBox_3" />
        {managementVehicleValidation.driveTrainError.length > 0 ? <p className='validMessage'>{managementVehicleValidation.driveTrainError}</p> : null}
      </Col>
      : null}
      {showDropDown?.showFuelType ?
      <Col xs={12} sm={4} md={4} lg={4} className='mb-md-3 mb-2'>
        <Label data-attribute="ManagementVehicle_Default_Label_4">Fuel Type</Label>
        <ReactSelectBox
          options={dropDownValues?.fuelTypeDropDown}
          onChange={(item: any) => fuelTypeOnChange(item)}
          value={orderDetails?.fuelType}
          selectRef={(element: any) => managementRef.current[3] = element}
          className={managementVehicleValidation?.fuelTypeError?.length > 0 ? 'controlValidation' : ''}
         data-attribute="ManagementVehicle_Default_SearchSelectBox_4" />
      </Col>
      : null}
      <Col xs={10} sm={10} md={10} lg={10} className='mt-2 mt-sm-0 mb-md-0 mb-2'>
        {!isEditRequestClick && 
        <>
          <Label required data-attribute="ManagementVehicle_Default_Label_5">Quantity</Label>
          <Quantity
            value={orderDetails.quantity}
            disableFlg={orderDetails.quantity <= 1}
            inputRef={(element: any) => managementRef.current[4] = element}
            onKeyPress={(event: any) => { isMaxLength(event, 2); isNumber(event); }}
            decrement={onDecrementQuantity}
            increment={onIncrementQuantity}
            onChange={onChangeQuantity}
           data-attribute="ManagementVehicle_Default_Quantity" />
          {managementVehicleValidation.quantityError.length > 0 ? <p className='validMessage'>{managementVehicleValidation.quantityError}</p> : null}
        </>}
      </Col>
      <Col xs={2} sm={2} md={2} lg={2}>
        <div className='pull-right rightAdd'>
          {!isEditRequestClick ?
            showAddItem && 
            <PrimaryButton btnRef={(element: any) => props.managementRef.current[5] = element} text='Add Item' onClick={props.addOnClick} data-attribute="ManagementVehicle_Default_Button"></PrimaryButton>
            :
            <div className='editTypeBtnBlock'>
              {
                showAddItem &&
                <>
                  <PrimaryButton text='Update Request' onClick={updateOnClick} className='me-2' disabled={!isAuthorized(permissions.RequisitionsCreateUpdate) || !isAuthorized(permissions.CreateUpdateTransfers)} data-attribute="ManagementVehicle_Default_Button_2"></PrimaryButton>
                  <OutlineButton text='Cancel Request' onClick={cancelEditRequestType} className='me-0' disabled={!isAuthorized(permissions.RequisitionsCreateUpdate) || !isAuthorized(permissions.CreateUpdateTransfers)} data-attribute="ManagementVehicle_Default_Button_3" />
                </>
              }
            </div>
          }
        </div>
      </Col>
    </Row>
    {popupContent.isDialogVisible &&
      <CancelConfirmationPopup
        hideDialog={!popupContent.isDialogVisible}
        onDismiss={hideDialog}
        Popupcontent={popupContent}
        popupOutlinebtnOnclick={() => popupContent.popupOutlinebtnOnclick()}
        popupPrimarybtnOnclick={() => popupContent.popupPrimarybtnOnclick()}
      />
    }
  </div>
}

export default ManagmentVehicle;
